"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _grid = _interopRequireDefault(require("cccisd-icons/grid3"));
var _menu = _interopRequireDefault(require("cccisd-icons/menu7"));
var _folderPlus = _interopRequireDefault(require("cccisd-icons/folder-plus"));
var _filePlus = _interopRequireDefault(require("cccisd-icons/file-plus"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil"));
var _info = _interopRequireDefault(require("cccisd-icons/info"));
var _fileUpload = _interopRequireDefault(require("cccisd-icons/file-upload"));
var _mic = _interopRequireDefault(require("cccisd-icons/mic2"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _image = _interopRequireDefault(require("cccisd-icons/image2"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross4"));
var _search = _interopRequireDefault(require("cccisd-icons/svg/search2"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _assets = require("../../reducers/assets.js");
var _assets2 = require("../../selectors/assets.js");
var _reactRedux = require("react-redux");
var _classnames2 = _interopRequireDefault(require("classnames"));
var _AddFolderForm = _interopRequireDefault(require("./AddFolderForm"));
var _GenerateSpeechForm = _interopRequireDefault(require("./GenerateSpeechForm"));
var _RenameFolderForm = _interopRequireDefault(require("./RenameFolderForm"));
var _RenameFileForm = _interopRequireDefault(require("./RenameFileForm"));
var _MoveForm = _interopRequireDefault(require("./MoveForm"));
var _ImageEditor = _interopRequireDefault(require("./ImageEditor"));
var _FileInfo = _interopRequireDefault(require("./FileInfo"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Component = /*#__PURE__*/function (_React$Component) {
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Component, [].concat(args));
    _defineProperty(_this, "state", {
      loading: false
    });
    _defineProperty(_this, "setViewMode", function (mode, e) {
      e && e.preventDefault();
      _this.props.setViewMode(mode);
    });
    _defineProperty(_this, "setSortBy", function (e) {
      _this.props.setSortBy(e.target.value);
    });
    _defineProperty(_this, "onFilterKeyDown", function (e) {
      e.nativeEvent.stopImmediatePropagation();
    });
    _defineProperty(_this, "setFilter", function (e) {
      _this.props.setFilter(e.target.value);
    });
    _defineProperty(_this, "deleteItem", function (e) {
      e.preventDefault();
      if (!_this.props.selectedFile && !_this.props.selectedFolder) {
        return;
      }
      (0, _cccisdConfirm["default"])({
        message: 'Confirm delete?',
        description: "Are you sure you want to delete selected ".concat(_this.props.selectedFile ? 'file' : 'folder', "?"),
        confirmLabel: 'Yes',
        abortLabel: 'Cancel'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                loading: true
              });
              _context.next = 3;
              return _this.props.removeSelectedItem();
            case 3:
              _this.setState({
                loading: false
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
    });
    return _this;
  }
  _inherits(Component, _React$Component);
  return _createClass(Component, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.isInfoModal && !prevProps.isInfoModal) {
        this.infoModal.open();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        selectedFile = _this$props.selectedFile,
        selectedFolder = _this$props.selectedFolder,
        sortBy = _this$props.sortBy,
        filter = _this$props.filter,
        allowTts = _this$props.allowTts,
        ttsContent = _this$props.ttsContent;
      var disableImageEditor = !selectedFile || !/\.(jpg|jpeg|png)$/.test(selectedFile.url);
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.state.loading
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].wrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-toolbar ".concat(_style["default"].toolbar)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group me-2"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames2["default"])('btn', 'btn-secondary', {
          active: this.props.viewMode === 'thumbnail'
        }),
        onClick: this.setViewMode.bind(null, 'thumbnail'),
        title: "Thumbnail view"
      }, /*#__PURE__*/_react["default"].createElement(_grid["default"], null)), /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames2["default"])('btn', 'btn-secondary', {
          active: this.props.viewMode === 'list'
        }),
        onClick: this.setViewMode.bind(null, 'list'),
        title: "List view"
      }, /*#__PURE__*/_react["default"].createElement(_menu["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group me-2"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        renderTrigger: function renderTrigger(_ref2) {
          var onClick = _ref2.onClick;
          return /*#__PURE__*/_react["default"].createElement("a", {
            className: "btn btn-secondary",
            title: "Add folder",
            onClick: onClick
          }, /*#__PURE__*/_react["default"].createElement(_folderPlus["default"], null));
        },
        title: "Add folder"
      }, /*#__PURE__*/_react["default"].createElement(_AddFolderForm["default"], null)), /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-secondary",
        title: "Upload file",
        onClick: this.props.openFileDialog
      }, /*#__PURE__*/_react["default"].createElement(_filePlus["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group me-2"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        renderTrigger: function renderTrigger(_ref3) {
          var onClick = _ref3.onClick;
          return /*#__PURE__*/_react["default"].createElement("a", {
            className: "btn btn-secondary",
            title: "Rename",
            disabled: !selectedFile && !selectedFolder,
            onClick: onClick
          }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null));
        },
        triggerDisabled: !selectedFile && !selectedFolder,
        title: "Rename"
      }, selectedFile ? /*#__PURE__*/_react["default"].createElement(_RenameFileForm["default"], null) : /*#__PURE__*/_react["default"].createElement(_RenameFolderForm["default"], null)), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        renderTrigger: function renderTrigger(_ref4) {
          var onClick = _ref4.onClick;
          return /*#__PURE__*/_react["default"].createElement("a", {
            className: "btn btn-secondary",
            title: "Move",
            disabled: !selectedFile && !selectedFolder,
            onClick: onClick
          }, /*#__PURE__*/_react["default"].createElement(_fileUpload["default"], null));
        },
        triggerDisabled: !selectedFile && !selectedFolder,
        title: "Where to move?"
      }, /*#__PURE__*/_react["default"].createElement(_MoveForm["default"], null)), /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-secondary",
        title: "Delete",
        disabled: !selectedFile && !selectedFolder,
        onClick: this.deleteItem
      }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        renderTrigger: function renderTrigger() {
          return /*#__PURE__*/_react["default"].createElement("a", {
            className: "btn btn-secondary",
            title: "Info",
            disabled: !selectedFile && !selectedFolder,
            onClick: _this2.props.showInfoModal
          }, /*#__PURE__*/_react["default"].createElement(_info["default"], null));
        },
        triggerDisabled: !selectedFile && !selectedFolder,
        title: "Preview",
        size: "small",
        ref: function ref(elem) {
          _this2.infoModal = elem;
        },
        afterClose: function afterClose() {
          return _this2.props.showInfoModal(false);
        }
      }, /*#__PURE__*/_react["default"].createElement(_FileInfo["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group me-2"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        renderTrigger: function renderTrigger(_ref5) {
          var onClick = _ref5.onClick;
          return /*#__PURE__*/_react["default"].createElement("a", {
            className: "btn btn-secondary",
            title: "Edit image",
            disabled: disableImageEditor,
            onClick: onClick
          }, /*#__PURE__*/_react["default"].createElement(_image["default"], null));
        },
        triggerDisabled: disableImageEditor,
        title: "Image Editor",
        size: "large"
      }, /*#__PURE__*/_react["default"].createElement(_ImageEditor["default"], {
        onImageUpdate: this.props.onImageUpdate
      }))), allowTts && /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        renderTrigger: function renderTrigger(_ref6) {
          var onClick = _ref6.onClick;
          return /*#__PURE__*/_react["default"].createElement("a", {
            className: "btn btn-secondary",
            title: "Generate Speech",
            onClick: onClick
          }, /*#__PURE__*/_react["default"].createElement(_mic["default"], null));
        },
        title: "Generate Speech"
      }, /*#__PURE__*/_react["default"].createElement(_GenerateSpeechForm["default"], {
        initialContent: ttsContent
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames2["default"])(_style["default"].filterBlock, _defineProperty({}, _style["default"].isFilter, filter))
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].search
      }, /*#__PURE__*/_react["default"].createElement(_search["default"], null)), /*#__PURE__*/_react["default"].createElement("input", {
        className: "form-control form-control-sm",
        type: "text",
        style: {
          width: '10em'
        },
        name: "filter",
        value: filter,
        onChange: this.setFilter,
        onKeyDown: this.onFilterKeyDown,
        placeholder: "Search"
      }), filter && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].cleanButton,
        onClick: function onClick() {
          return _this2.props.setFilter('');
        }
      }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-select form-select-sm",
        style: {
          width: 'auto',
          marginLeft: '.5em'
        },
        value: sortBy,
        onChange: this.setSortBy,
        id: "sortBySelect"
      }, _assets.sortByOptions.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: option.value,
          value: option.value
        }, option.label);
      })))));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Component, "propTypes", {
  viewMode: _propTypes["default"].string,
  sortBy: _propTypes["default"].string,
  filter: _propTypes["default"].string,
  setViewMode: _propTypes["default"].func,
  setSortBy: _propTypes["default"].func,
  setFilter: _propTypes["default"].func,
  showInfoModal: _propTypes["default"].func,
  openFileDialog: _propTypes["default"].func,
  selectedFile: _propTypes["default"].object,
  selectedFolder: _propTypes["default"].object,
  isInfoModal: _propTypes["default"].bool,
  allowTts: _propTypes["default"].bool,
  ttsContent: _propTypes["default"].string,
  removeSelectedItem: _propTypes["default"].func,
  onImageUpdate: _propTypes["default"].func
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    sortBy: state.resources.assets.sortBy,
    filter: state.resources.assets.filter,
    selectedFile: (0, _assets2.getOneSelectedFile)(state.resources.assets),
    selectedFolder: (0, _assets2.getOneSelectedFolder)(state.resources.assets),
    viewMode: state.resources.assets.viewMode,
    isInfoModal: state.resources.assets.isInfoModal
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  setViewMode: _assets.setViewMode,
  setSortBy: _assets.setSortBy,
  setFilter: _assets.setFilter,
  showInfoModal: _assets.showInfoModal,
  removeSelectedItem: _assets.removeSelectedItem
})(Component);